import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './index.scss';

const DropdownList = ({ options = [], _handleClick, locationName, disabled=false }) => {


	 //sorting for location 
	options.sort(function (a, b) {
		return a.name.localeCompare(b.name);
		});
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(prevState => !prevState);

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className='file-upload-dropdown' disabled={disabled}>
			<label className='required d-block'>
				Work Group
			</label>
			<DropdownToggle caret className='d-flex'>
				<label>  {locationName}</label>
				<span className='ms-auto'>
					{options.length <= 1 ? (
						<div></div>
					) : (
						<FontAwesomeIcon icon={faAngleDown} />
					)}
				</span>
			</DropdownToggle>
			{
				options.length <= 1 ? (<div></div>) : (
			<DropdownMenu>
				{options.length !== 0 && options.map((item, index) => {
					return (
						<DropdownItem key={index} onClick={_handleClick} dropDownValue={item._id}>{item.name}</DropdownItem>
					);
				})}
			</DropdownMenu>
				)
			}
			
		</Dropdown>
	);
}

export default DropdownList;